<!-- 
Dialog for rebuilding the database.

This is a testing tool only and is not available in production.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Rebuild database</v-toolbar-title>
          <v-spacer/>
          <our-user-guide-button topic="common" section="database-rebuild"/>
        </v-toolbar>
        <our-busy-indicator :show="processing"/>
        <v-card-text>
          <p class="subheading">
            Rebuild the database and:
          </p>
          <v-radio-group v-model="rebuildType" :rules="[rules.required]">
            <v-radio :value="productionDataWithProviders" color="primary" label="Seed with basic information" />
            <v-radio :value="productionDataNoProviders" color="primary" label="Seed with basic information, without providers" />
            <v-radio :value="sampleData" color="primary" label="Seed with some sample data, for use when automation testing" />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="processing" flat @click="hide">Cancel</v-btn>
          <v-btn 
            :disabled="processing"
            flat class="rebuild-button" 
            color="error" @click="rebuild"
          >
            Rebuild
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error" />
  </v-dialog>
</template>

<script>
import * as action from "@/store/system/action-types";
import * as mutation from "@/store/system/mutation-types";
import { SIGN_OUT } from "@/store/users/action-types";
import ruleMixins from "@/mixins/rule.mixins";

export default {
  mixins: [ruleMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showValidationDialog: false,
      rebuildType: null,
      sampleData: "sample-data",
      productionDataWithProviders: "production-with-providers",
      productionDataNoProviders: "production-no-providers"
    };
  },
  computed: {
    state() {
      return this.$store.state.system.rebuild;
    },
    processing() {
      return this.state.processing;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        this.$refs.form.reset();
        this.$store.commit(mutation.REBUILD_INITIALISE);
      }
    }
  },
  methods: {
    async rebuild() {
      const showValidationDialog = !this.$refs.form.validate();
      if (!showValidationDialog) {
        const productionDataOnly =
          this.rebuildType == this.productionDataWithProviders || this.rebuildType == this.productionDataNoProviders;
        const importProviders = this.rebuildType == this.productionDataWithProviders;
        const options = { productionDataOnly, importProviders };
        this.showValidationDialog = !(await this.$store.dispatch(action.REBUILD, options));
        this.hide();
        if (!this.showValidationDialog) {
          if (this.$store.getters.isSignedIn) {
            await this.$store.dispatch(SIGN_OUT);
          }
          this.$router.push("/sign-in");
        }
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
